import React from "react";

export const Loading = ({ label = "Loading" }) => (
  <div
    data-testid="page-loading"
    className="flex items-center justify-center py-20"
  >
    <div className="flex items-center gap-3">
      <div className="w-2 h-2 rounded-full bg-[#2A1C15] bj-live" />
      <span className="font-heading tracking-widest text-[#6E5022] text-sm uppercase">
        {label}…
      </span>
    </div>
  </div>
);

export const ErrorState = ({ message, onRetry, testid = "page-error" }) => (
  <div
    data-testid={testid}
    className="border border-[#5C1A24]/30 p-6 text-center max-w-xl mx-auto my-10"
  >
    <div className="font-heading text-[#5C1A24] tracking-widest text-sm mb-2 uppercase">
      Connection Error
    </div>
    <div className="text-[#5E4D40] text-xs mb-4 break-words">{message}</div>
    {onRetry && (
      <button
        onClick={onRetry}
        data-testid="error-retry-button"
        className="px-4 py-1.5 border border-[#C8A46A] text-[#6E5022] font-heading tracking-widest text-xs uppercase hover:bg-[#2A1C15] hover:text-[#DCCFB9] transition-colors"
      >
        Retry
      </button>
    )}
  </div>
);

export const EmptyRow = ({ colSpan, message = "No records yet." }) => (
  <tr>
    <td colSpan={colSpan} className="py-10 text-center text-[#5E4D40] text-sm">
      {message}
    </td>
  </tr>
);
